// removed by extract-text-webpack-plugin
module.exports = {"page":"_32KaTiYwG _17qxy1jyE","content":"_2ducH29ga","error":"_1rwTMlH3b"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ticketing-page/ticketing-page.css
 ** module id = 2201
 ** module chunks = 0
 **/